import React, { useState } from "react";
import {
  Button,
  Input,
  Select,
  Drawer,
  Radio,
  Modal,
} from "antd";
import Close from "../../../../assets/images/close-x.svg";
import db from "../../../../database";
import useRestaurantStore from "../../../../stores/useRestaurantStore";
import { getWorkflowData } from "../../../../utils/getWorkflowData";

const returnReasons = ["Damaged Item", "Wrong Item Delivered", "Quality Issue", "Customer Changed Mind", "Expired Product", "Other"];

const ReturnItemDrawer = ({
  returnDrawerOpen,
  setReturnDrawerOpen,
  returnItem,
  returnQty,
  setReturnQty,
  currenciesList,
  dataSource,
  setDataSource,
  handleSaveReturnCartRecord,
  setCheckedKeys,
  addSelectedReturnProductsToCart,
  setKeyValue,
  selectedReturnOrder,
  selectedOrder,
  sortedSaleTypes,
  setSelectedSaleTypeIndex,
  handleSelectedSaleTypeForProducts,
  setSaleType,
  setSalesHistoryDrawer,
  dispatchEvent,
}) => {
  const [returnType, setReturnType] = useState("wastage");
  const [reasonCode, setReasonCode] = useState(null);
  const [notes, setNotes] = useState("");
  const [reasonError, setReasonError] = useState(false);

  const submitReturn = async () => {
    if (!returnItem) return;

    const data = [...dataSource]; // table data (same as original)

    // find row in dataSource
    const row = data.find((r) => r.sOrderlineID === returnItem.sOrderlineID);

    if (!row) return;

    // set qtyToReturn like table edit
    row.qtyToReturn = returnQty;

    // update state like original
    setDataSource(data);
    handleSaveReturnCartRecord(data);

    // select this row
    const keys = [row.key];
    setCheckedKeys(keys);
    if (returnType === "wastage") {
      localStorage.setItem("wastageFlag", "Y");
      useRestaurantStore.getState().setWastageflag("Y");
    } else {
      localStorage.removeItem("wastageFlag");
      useRestaurantStore.getState().setWastageflag(null);
    }
    // pass keys directly to avoid stale state from async setCheckedKeys
setReturnDrawerOpen(false);
setSalesHistoryDrawer(false);

setKeyValue("2");

setTimeout(async () => {
  try {
    const allSaleTypes = await db.posSaletypes.toArray();

    const orderSaleTypeId =
      selectedReturnOrder?.saleType?.cwrSaletypeId ||
      selectedOrder?.saleType?.cwrSaletypeId;

    if (!orderSaleTypeId) return;

    const matchedSaleType = allSaleTypes.find(
      (s) => s.cwrSaletype?.cwrSaletypeId === orderSaleTypeId
    );

    if (!matchedSaleType) return;

    const index = sortedSaleTypes.findIndex(
      (s) => s.cwrSaletype?.cwrSaletypeId === orderSaleTypeId
    );

    if (index !== -1) {
      setSelectedSaleTypeIndex(index);
    }

    // SWITCH SALE TYPE FIRST
    handleSelectedSaleTypeForProducts(matchedSaleType)();

    setSaleType(matchedSaleType.cwrSaletype?.value);

    // wait a little for state updates
    setTimeout(async () => {
      await addSelectedReturnProductsToCart(keys);
    }, 200);

  } catch (e) {
    // best-effort sale-type switch for the return cart; return itself already staged above
  }
}, 100);
  };

  const handleProcessReturn = async () => {
    // inline reason validation
    if (!reasonCode) {
      setReasonError(true); // show red text under dropdown
      return;
    }

    // clear error if valid
    setReasonError(false);

    // if stock -> gate on the configured "Sales Return" workflow rule/PIN,
    // same mechanism SMPurchaseReturnView.js uses for Retail (BUG-2106: this
    // used to show a hardcoded confirmation with no PIN check at all)
    if (returnType === "stock") {
      const { workflowRules, approvers } = await getWorkflowData();
      const salesReturnRule = workflowRules.find(
        (res) => res.eventName === "Sales Return Process" || res.eventName === "Sales Return Approval"
      );

      if (salesReturnRule && dispatchEvent) {
        dispatchEvent(salesReturnRule.eventName, salesReturnRule.ruleName, salesReturnRule.ruleCondition, approvers, null, (eventData) => {
          if (eventData?.approvalGranted) {
            submitReturn();
          } else {
            Modal.error({
              title: "Approval Required",
              content: "The sales return request was not approved.",
            });
          }
        });
      } else {
        // no rule configured for this till/store — proceed as before
        submitReturn();
      }
      return;
    }

    // normal wastage return
    submitReturn();
  };

  return (
    <>
      <Drawer
        placement="right"
        width="62%"
        rootClassName="return-item-drawer"
        open={returnDrawerOpen}
        onClose={() => setReturnDrawerOpen(false)}
        closable={false}
        styles={{
          header: { background: "#f3f4f6", borderBottom: "none" },
          body: { padding: "1.5rem", paddingTop: "0", background: "#f3f4f6" },
          mask: { backgroundColor: "rgba(0, 0, 0, 0.3)" },
        }}
        title={
          <div
            className="return-item-title-row"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              paddingTop: "15px",
              background: "#f3f4f6",
            }}
          >
            <div>
              <div style={{ fontSize: "22px", fontWeight: 600, color: "#2f3856", marginBottom: "5px" }}>Return Item</div>
              <div style={{ fontSize: "14px", color: "#666" }}>Process return for {returnItem?.name}</div>
            </div>

            <img src={Close} onClick={() => setReturnDrawerOpen(false)} style={{ cursor: "pointer", width: 16, height: 18 }} />
          </div>
        }
      >
        {returnItem && (
          <div
            className="return-item-body"
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            {/* ITEM CARD */}
            <div
              className="return-item-card"
              style={{
                border: "1px solid #e6e6e6",
                borderRadius: "10px",
                padding: "14px",
                marginBottom: "10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ fontSize: "15px", fontWeight: 600 }}>{returnItem?.product?.name || returnItem?.name}</div>
                <div style={{ fontSize: "13px", color: "#777" }}>
                  Qty: {returnItem?.qty} × {returnItem?.grossstd || returnItem?.salePrice}
                </div>
              </div>

              <div style={{ fontSize: "15px", fontWeight: 600 }}>
                {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""} {returnItem.salePrice}{" "}
                {currenciesList[0].symbolRightSide === "N" ? `${currenciesList[0].currSymbol} ` : ""}
              </div>
            </div>

            {/* RETURN QTY */}
            <div style={{ marginBottom: "10px" }}>
              <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "6px" }}>Return Quantity</div>

              <Select value={returnQty} onChange={setReturnQty} style={{ width: "100%" }}>
                {Array.from({ length: returnItem.remainingQty }, (_, i) => (
                  <Select.Option key={i + 1} value={i + 1}>
                    {i + 1}
                  </Select.Option>
                ))}
              </Select>
            </div>

            {/* RETURN TYPE */}
            <div style={{ marginBottom: "10px" }}>
              <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "8px" }}>Return Type</div>

              <Radio.Group value={returnType} onChange={(e) => setReturnType(e.target.value)} style={{ width: "100%" }}>
                {/* WASTAGE */}
                <div
                  style={{
                    border: "1px solid #e6e6e6",
                    borderRadius: "10px",
                    padding: "12px 14px",
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Radio value="wastage">Wastage</Radio>

                  <span
                    style={{
                      background: "#f3f4f6",
                      fontSize: "12px",
                      padding: "2px 8px",
                      borderRadius: "6px",
                    }}
                  >
                    Default
                  </span>
                </div>

                {/* STOCK */}
                <div
                  style={{
                    border: "1px solid #e6e6e6",
                    borderRadius: "10px",
                    padding: "12px 14px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Radio value="stock">Add Back to Stock</Radio>

                  <span style={{ fontSize: "12px", color: "#f59e0b" }}>Requires Approval</span>
                </div>
              </Radio.Group>
            </div>

            {/* REASON */}
            <div style={{ marginBottom: "18px" }}>
              <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "6px" }}>Reason Code *</div>

              <Select
                value={reasonCode}
                onChange={(val) => {
                  setReasonCode(val);
                  setReasonError(false); // clear error when selected
                }}
                placeholder="Select a reason"
                style={{
                  width: "100%",
                  border: reasonError ? "1px solid #ff4d4f" : undefined,
                  borderRadius: 6,
                }}
              >
                {returnReasons.map((reason) => (
                  <Select.Option key={reason} value={reason}>
                    {reason}
                  </Select.Option>
                ))}
              </Select>

              {reasonError && (
                <div
                  style={{
                    color: "#ff4d4f",
                    fontSize: "12px",
                    marginTop: "6px",
                  }}
                >
                  Please select a reason code
                </div>
              )}
            </div>

            {/* NOTES */}
            <div style={{ marginBottom: "30px" }}>
              <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "6px" }}>Additional Notes (Optional)</div>

              <Input.TextArea rows={2} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Enter any additional notes..." />
            </div>
            <div
              className="return-item-footer"
              style={{
                position: "sticky",
                bottom: 0,
                background: "#f3f4f6",
                padding: "0",
                borderTop: "1px solid #e6e6e6",
              }}
            >
              <div style={{ display: "flex", gap: "12px" }}>
                <Button
                  style={{
                    flex: 1,
                    height: "48px",
                    borderRadius: "8px",
                    fontWeight: 500,
                  }}
                  onClick={() => setReturnDrawerOpen(false)}
                >
                  Cancel
                </Button>

                <Button
                  style={{
                    flex: 1,
                    height: "48px",
                    borderRadius: "8px",
                    background: "#111",
                    color: "#fff",
                    border: "none",
                    fontWeight: 500,
                  }}
                  onClick={handleProcessReturn}
                >
                  Process Return
                </Button>
              </div>
            </div>
          </div>
        )}
      </Drawer>
    </>
  );
};

export default ReturnItemDrawer;
